import { apiJson, replaceUserEndpoint } from './userEndpoint';

export async function fetchInjuryReport({
	endpointTemplate,
	userId,
	csrfToken,
	params = {}
}) {
	const url = new URL(replaceUserEndpoint(endpointTemplate, { userId }), window.location.origin);

	Object.entries(params).forEach(([key, value]) => {
		if (value != null && value !== '') {
			url.searchParams.set(key, value);
		}
	});

	return apiJson(url.toString(), { csrfToken });
}
